import type { ModuleRoute } from '../util'
import { mixinParams } from '../util'
import { THESIS_TYPE } from '@/views/teacher/thesis/v2/constant'

export const thesisV3ManagerRouteMap = {
  30001: {
    path: 'v3/manage',
    name: 'ThesisAdviseManage',
    component: () => import('@/views/teacher/thesis/v3/ThesisManagePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Manage.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30001],
      moduleChildren: [],
    },
  },
  30002: {
    path: 'v3/advise',
    name: 'ThesisAdviseMine',
    component: () => import('@/views/teacher/thesis/v3/ThesisAdvisePage.vue'),
    props: {
      type: THESIS_TYPE.enums.Advisor.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30002],
      moduleChildren: [],
    },
  },
}
mixinParams({ ...thesisV3ManagerRouteMap }, { moduleName: 'thesis' })

export default {
  path: '/:symbol([A-Za-z]+)/manager/:module(thesis)/',
  component: () => import('@/components/teacher/layout/ManagerPageLayout.vue'),
  children: Object.values(thesisV3ManagerRouteMap as ModuleRoute).concat([{
    path: 'v3/advise/detail',
    name: 'ThesisAdviseDetail',
    component: () => import('@/views/teacher/thesis/v3/ThesisAdviseDetailPage.vue'),
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30000, 30002],
      moduleChildren: [],
    },
  }]),
}
